var nb = require('../nb');
var swiperItem = nb.define({
    view: {
        'class': 'swiper-slide',
        tag: 'a',
        href: nb.bind('swiperItemHref'),
        target: '_blank',
        $html: {
            tag: 'img',
            src: nb.bind('imgUrl'),
            alt: nb.bind('title')
        }
    }
});
var swiperItem2 = nb.define({
    view: {
        'class': 'swiper-slide',
        tag: 'a',
        href: nb.bind('swiperItemHref'),
        target: '_blank',
        style: {
            'background-image': nb.bind('imgUrl')
        }
    }
});
var swiperItem3 = nb.define({
    view: {
        'class': 'swiper-slide',
        $html: {
            tag: 'img',
            src: nb.bind('imgUrl'),
            alt: nb.bind('title')
        }
    }
});
var swiperWrapper = nb.define({
    parent: nb.view.List,
    view: {
        'class': 'swiper-wrapper'
    }
});
var Swiper = nb.define({
    view: {
        'class': 'swiper-container',
        'id': nb.bind('swiperId'),
        $html: [{
            $type: swiperWrapper,
            $model: 'swiperList'
        }, {
            'class': 'swiper-pagination'
        }]
    }
});

module.exports = {
    Swiper: Swiper,
    swiperItem: swiperItem,
    swiperItem2: swiperItem2,
    swiperItem3:swiperItem3
};


//////////////////
// WEBPACK FOOTER
// ../src/js/view/Swiper.js
// module id = 103
// module chunks = 0 1 2